import { Injectable } from "@angular/core";
import { CoreService } from "../../../base/core";
import { ServiceRoute } from "../../../base/service-route";
import { CommonHttpOption } from "../../../base/common-http-option";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubsidiaryStudentService {
  constructor(private coreService: CoreService) {}
  
 // get CustomerContractNationalList
  getStudentsInContract(params: any, pageIndex: number = 1, pageSize: number = 10): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.dashboard.student.getStudentsInContract,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(pageIndex, pageSize)  
      .append('Id', params && params.Id ? params.Id : '')
      .append('ContractId', params && params.ContractId ? params.ContractId : '')
      .append('Nationalcode', params && params.Nationalcode ? params.Nationalcode : '')
      .append('FullName', params && params.FullName ? params.FullName : '')
      .append('PhoneNumber', params && params.PhoneNumber ? params.PhoneNumber : '')
      .append('Gender', params && params.Gender ? params.Gender : '')
  );
  }
    // add student 
    contractPersonDirectAdd(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.dashboard.student.contractPersonDirectAdd,
        command,
        new CommonHttpOption().headers
      );
    }
 // get getCustomerListCombo
  getCustomerListCombo(): Observable<any> {
    return this.coreService.get(
      ServiceRoute.subsidiary.company.getCustomerListCombo,
      new CommonHttpOption().headers
  );
  }
    // add customer 
    addCustomer(command: any): Observable<any> {
      return this.coreService.post(
        ServiceRoute.subsidiary.company.customerAdd,
        command,
        new CommonHttpOption().headers
      );
    }
  
    // edit customer 
    customerEdit(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.company.customerEdit,
      command,
      new CommonHttpOption().headers
    );
  }
    // customerActiveDeactive 
    customerActiveDeactive(command: any): Observable<any> {
    return this.coreService.put(
      ServiceRoute.subsidiary.company.customerActiveDeactive,
      command,
      new CommonHttpOption().headers
    );
  }

      // Contract File XLS  
      contractFileXLS(command: any): Observable<any> {
        return this.coreService.post(
          ServiceRoute.subsidiary.dashboard.student.ContractFileXLS,
          command,
          new CommonHttpOption().headers
        );
      }



}
